var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPenTool(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3331 29.9998H17.6931C18.9731 29.9998 19.7998 29.0932 19.5598 27.9865L19.0131 25.5732H13.0131L12.4664 27.9865C12.2264 29.0265 13.1331 29.9998 14.3331 29.9998Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0134 25.5602L21.3201 23.5069C22.6134 22.3602 22.6667 21.5601 21.6401 20.2668L17.5734 15.1069C16.7201 14.0269 15.3201 14.0269 14.4667 15.1069L10.4001 20.2668C9.37341 21.5601 9.3734 22.4002 10.7201 23.5069L13.0267 25.5602",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0137 14.8271V18.2005",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.693 6.66699H15.3597C14.6264 6.66699 14.0264 6.06699 14.0264 5.33366V4.00033C14.0264 3.26699 14.6264 2.66699 15.3597 2.66699H16.693C17.4264 2.66699 18.0264 3.26699 18.0264 4.00033V5.33366C18.0264 6.06699 17.4264 6.66699 16.693 6.66699Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.3597 18.8936H5.69303C6.42637 18.8936 7.02637 18.2936 7.02637 17.5603V16.227C7.02637 15.4936 6.42637 14.8936 5.69303 14.8936H4.3597C3.62637 14.8936 3.02637 15.4936 3.02637 16.227V17.5603C3.02637 18.2936 3.62637 18.8936 4.3597 18.8936Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6393 18.8936H26.306C25.5727 18.8936 24.9727 18.2936 24.9727 17.5603V16.227C24.9727 15.4936 25.5727 14.8936 26.306 14.8936H27.6393C28.3727 14.8936 28.9727 15.4936 28.9727 16.227V17.5603C28.9727 18.2936 28.3727 18.8936 27.6393 18.8936Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0267 4.74707C8.94667 5.34707 5 9.65372 5 14.8937",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9997 14.8937C26.9997 9.66705 23.0797 5.37374 18.0264 4.74707",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPenTool);
export default __webpack_public_path__ + "static/media/pen-tool.8c354b95f7152f40e2d072be5b5c24cf.svg";
export { ForwardRef as ReactComponent };